import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null,
};

const userAuthTokenSlice = createSlice({
  name: "userToken",
  initialState,
  reducers: {
    addUserToken: (state, action) => {
      state.user = action.payload;

      localStorage.setItem(
        "user",
        JSON.stringify(action.payload)
      );
    },

    clearUserToken: (state) => {
      localStorage.clear();
      sessionStorage.clear();
      state.user = null;
      localStorage.removeItem("user");
    },
  },
});

export const { addUserToken, clearUserToken } =
  userAuthTokenSlice.actions;

export const selectUser = (state) => state?.userToken?.user;

export default userAuthTokenSlice.reducer;